:host {
    display: block;
    position: relative; // This is needed for IE11

    * {
        box-sizing: border-box;
    }

    .ti-sticky-header-wrapper {
        width: 100%;

        .ti-sticky-header-content {
            width: 100%;
            background: transparent;//$pl-container-background-color-primary;
            display: flex;
            flex-direction: column;

            &.ti-sticky-header-sticky {
                position: fixed;
                z-index: 200;
                top: 0;
                left: 0;
                box-shadow: $polaris-boxShadow-4;
                animation: $polaris-animation-timing-enter $polaris-animation-easing-decelerate reveal-from-top forwards;
            }

            .ti-sticky-header-top {
                background: $pl-container-background-color-primary;
                overflow: visible;
                transition: height .3s;
            }
        }
    }
}

:host([disable-animation]) {
    .ti-sticky-header-content.ti-sticky-header-sticky {
        animation: none;
    }
    .ti-sticky-header-top {
        transition: none;
    }
}

:host(.ti-sticky-header-desktop) {
    .ti-sticky-header-wrapper {
        margin: var(--tiStickyHeader-margin-block, -8px) 0; // workaround for flexbox increasing size
    }
}

@keyframes reveal-from-top {
    from {transform: translateY(-100%);}
    to {transform: translateY(0);}
}
